import { DatePipe } from '@angular/common';
import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { map, Observable, startWith } from 'rxjs';
import { Acesso } from 'src/app/models/bas/acesso/acesso';
import { CadastroGenerico } from 'src/app/models/cad/cadastro-generico/cadastro-generico';
import { Portador } from 'src/app/models/cad/portador/portador';
import { Titulo } from 'src/app/models/fin/titulo/titulo';
import { ResultadoArquivoRetorno } from 'src/app/models/fin/titulo/resultado-arquivo-retorno';
import { Pagamento } from 'src/app/models/fin/pagamento/pagamento';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AcessoService } from 'src/app/services/bas/acesso.service';
import { CadastroGenericoService } from 'src/app/services/cad/cadastro-generico.service';
import { PortadorService } from 'src/app/services/cad/portador.service';
import { RepresentanteService } from 'src/app/services/cml/representante.service';
import { BancoService } from 'src/app/services/fin/banco.service';
import { TituloService } from 'src/app/services/fin/titulo.service';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { CustomSnackBarService } from 'src/app/shared/components/custom-snack-bar/custom-snack-bar.service';
import { TrataExcessao } from 'src/app/shared/utils/trata-excessao';
import { ProdutoService } from 'src/app/services/cad/produto.service';

@Component({
  selector: 'app-actions-modal',
  templateUrl: './actions-modal.component.html',
  styleUrls: ['./actions-modal.component.scss']
})
export class ActionsModalComponent implements OnInit {

  currentDate;

  dialogRef: MatDialogRef<ActionsModalComponent>;

  titulo: Titulo;
  dialogData;
  
  acesso: Acesso | undefined = undefined;
  form: UntypedFormGroup;
  firstComparison = true;
  isLoading = false;
  countLoading = 0;
  habilitaPagamentos = false;

  listaPortadores: Portador[];
  listaPortadoresFiltrados: Observable<Portador[]>;

  listaMeioPagamento: CadastroGenerico[] = [];
  listaMeioPagamentoFiltradas: Observable<CadastroGenerico[]>;

  listaRepresentantes: Array<any> = [];

  listaSituacaoCheque: Array<any> = [];

  listaMotivoDevolucao: Array<any> = [];

  listaBancos: Array<any> = [];

  listaDivisao: CadastroGenerico[];
  listaDivisaoFiltradas: Observable<CadastroGenerico[]>;

  displayedColumns: string[] =
    [
      "dataHoraMovimento",
      "descricaoTipoMovimento",
      "valorMovimento",
      "idRemessaBanco",
      "enviarBanco",
      "numeroTituloRelacionado"
    ];

  displayedColumnsLiquidacao: string[] = [
    "linha",
    "retorno"
  ]

  displayedColumnsPagamentos: string[] = ['valor', 'dataPagamento', 'meioPagamento', 'actions'];

  dataSource = new MatTableDataSource<Titulo>();
  dataSourceResultado = new MatTableDataSource<ResultadoArquivoRetorno>();
  dataSourcePagamento = new MatTableDataSource<Pagamento>();

  @ViewChild("resultadoArquivo") resultadoArquivo: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @ViewChild("paginatorMovto") paginatorMovto: MatPaginator;
  @ViewChild(MatSort, { static: false }) sortMovto: MatSort;

  @ViewChild("liquidacaoAutomatica") liquidacaoAutomatica: ElementRef;
  @ViewChild("movimentos") movimentos: ElementRef;


  fileToUpload: File | null = null;

  isDragged = false

  liquiAutomaticaCarregou: boolean = false;

  sequenciaPagamento = 0;

  indLiquidado = false;
  indCancelado = false;
  indEmAtraso = false;

  constructor(
    private authService: AuthService,
    private snackBar: CustomSnackBarService,
    private injector: Injector,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private portadorService: PortadorService,
    private acessoService: AcessoService,
    private tituloService: TituloService,
	  private representanteService: RepresentanteService,
	  private bancoService: BancoService,    
    private cadastroGenericoService: CadastroGenericoService,
    private dialog: MatDialog,    
    public produtoService: ProdutoService,
  ) {
    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
	  this.currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    produtoService.resetModel();
    cadastroGenericoService.resetModel();
  }

  private genericErrorTreat(err) {
	  this.escondeCarregando();
	  TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
  }

  private preencherInfoTitulo() {
    if (this.dialogData["action"] == "Liquidar Manual") {
      this.exibirCarregando();
      this.tituloService.carregaLiquidacaoTitulo(this.dialogData['idTitulo']).subscribe({
        next: (response) => {          
          this.escondeCarregando();
          this.dialogData["titulo"] = response.body.retorno.registro[0]
        }, 
        error: (err) => { this.genericErrorTreat(err) }
      });
    }
  }

  verificaSelecionaDivisao(event, campo: string, campoCodigo: string) {
    if (event.srcElement.value === '') {
      this.form.controls[campo].setValue('');
      this.form.controls[campoCodigo].setValue(0);
    }
  }

  formatarInputValorProduto(preco) {
    if (preco && (preco.toString().includes(".") || preco.toString().includes(",")) && !(preco.toString().includes(".") && preco.toString().includes(","))) {
      preco = preco.toString()
      const lastIndex = preco.lastIndexOf('.');

      const replacement = ',';

      preco =
        preco.substring(0, lastIndex) +
        replacement +
        preco.substring(lastIndex + 1);
      if (preco.substring(0, 1) === ",") {
        preco = preco.substring(1)
      }
    }
    return preco
  }

  private exibirCarregando() {
    this.countLoading++;
    this.isLoading = true;
  }

  private escondeCarregando() {
    this.countLoading--;
    if (this.countLoading <= 0) {
      this.isLoading = false;
    }
  }

  private createForm() {
    switch (this.dialogData.action) {
      case "Liquidar Manual":
        this.form = this.formBuilder.group({
          nomePessoa: new UntypedFormControl({ value: '', disabled: true }),
          numDocumento: new UntypedFormControl({ value: '', disabled: true }),
          parcela: new UntypedFormControl({ value: '', disabled: true }),
          dataVencimento: new UntypedFormControl({ value: null, disabled: true }),
          dataLiquidacao: new UntypedFormControl({ value: null }),
          portadorOriginal: new UntypedFormControl({ value: '', disabled: true }),
          codPortadorOriginal: new UntypedFormControl({ value: '', disabled: true }),
          codPortador: [, Validators.required],
          portador: [, Validators.required],
          valorOriginal: ["0", Validators.required],
          valorALiquidar: ["0", Validators.required],
          valorDesconto: ["0", Validators.required],
          valorAbatimento: ["0", Validators.required],
          valorJuros: ["0", Validators.required],
          observacoes: [""],

        });
        this.exibirCarregando();
        this.tituloService.carregaLiquidacaoTitulo(this.dialogData['idTitulo']).subscribe({
          next: (response) => {            
            this.escondeCarregando();
            this.dialogData["titulo"] = response.body.retorno.registro[0];
            const dataAtual = new Date();
            dataAtual.setHours(0);
            dataAtual.setMinutes(0);
            dataAtual.setSeconds(0);
            dataAtual.setMilliseconds(0);

            this.form.controls["dataVencimento"].setValue(this.datePipe.transform(this.dialogData['titulo']['dataVencimento'], 'yyyy-MM-dd'))
            if (this.dialogData['titulo']['dataLiquidacao'])
            {
              this.form.controls["dataLiquidacao"].setValue(this.datePipe.transform(this.dialogData['titulo']['dataLiquidacao'], 'yyyy-MM-dd'))
            }
            else
            {
              this.form.controls["dataLiquidacao"].setValue(this.datePipe.transform(dataAtual, 'yyyy-MM-dd'))
            }			
            this.form.controls["valorOriginal"].setValue(this.dialogData['titulo']['valorTitulo'])
            this.form.controls["valorALiquidar"].setValue(this.dialogData['titulo']['valorSaldo'])
            this.form.controls["valorDesconto"].setValue(this.dialogData['titulo']['valorDesconto'])
            this.form.controls["valorAbatimento"].setValue(this.dialogData['titulo']['valorAbatimento'])
            this.form.controls["valorJuros"].setValue(this.dialogData['titulo']['valorJuros'])            
            this.form.controls["observacoes"].setValue(this.dialogData['titulo']['observacaoTitulo'])
            this.form.controls["codPortadorOriginal"].setValue(this.dialogData['titulo']['idPortador'])
            this.form.controls["nomePessoa"].setValue(this.dialogData['titulo']['nomePessoa'])
            this.form.controls["numDocumento"].setValue(this.dialogData['titulo']['numDocumento'])
            this.form.controls["parcela"].setValue(this.dialogData['titulo']['parcela'])
            this.form.controls["codPortador"].setValue(this.dialogData['titulo']['idPortador'])

            this.form.controls["valorOriginal"].disable()

            if (dataAtual > this.form.controls['dataVencimento'].value) {
              this.form.controls['valorDesconto'].disable()
            }

            this.portadorService.listarTodos().subscribe({
              next: (response) => {
                this.escondeCarregando();
                const resultado = response.body.retorno.registro

                this.listaPortadores = resultado;

                if (this.listaPortadores === undefined) {
                  this.listaPortadores = [];
                }

                let codigo = this.form.controls['codPortador'].value;

                if (codigo != 0) {
                  let selecionado: Portador = <Portador>this.listaPortadores.filter(registro => registro.idPortador == codigo)[0];
                  if (selecionado)
                    this.form.controls['portador'].setValue(selecionado);
                  this.form.controls['portadorOriginal'].setValue(selecionado.nome)
                }

                this.listaPortadoresFiltrados = this.form.controls['portador'].valueChanges
                  .pipe(
                    startWith(''),
                    map(value => value === undefined || value === null ? "" : value),
                    map(value => typeof value === 'string' ? value : value.nomeBanco),
                    map(name => {
                      return name ? this.filtraPortador(name) : this.listaPortadores.slice();
                    }));

              },
              error: (err) => { this.genericErrorTreat(err) }
            });
          },
          error: (err) => { this.genericErrorTreat(err) }
        });
        break;
      case "Pagamentos":
        this.form = this.formBuilder.group({
          nomePessoa: new UntypedFormControl({ value: '', disabled: true }),
          numDocumento: new UntypedFormControl({ value: '', disabled: true }),
          parcela: new UntypedFormControl({ value: '', disabled: true }),
          nossoNumero: new UntypedFormControl( { value: '', disabled: true}),
          dataVencimento: new UntypedFormControl({ value: '', disabled: true }),
          dataLiquidacao: new UntypedFormControl({ value: '' }),
          portadorOriginal: new UntypedFormControl({ value: '', disabled: true }),
          codPortadorOriginal: new UntypedFormControl({ value: '', disabled: true }),
          codPortador: [, Validators.required],
          portador: [, Validators.required],
          valorOriginal: ["0", Validators.required],
          valorALiquidar: ["0", Validators.required],
          valorDesconto: ["0", Validators.required],
          valorAbatimento: ["0", Validators.required],
          valorJuros: ["0", Validators.required],
          observacoes: [""],		  
          valorDescontoTitulo: ["0",Validators.required],
          valorDescontoFinanceiro: ["0"],
          meioPagamento: [],
          divisao: [0, ],
          codigoDivisao: [0, ],
          produtoDespesa: [,],
        });

        this.pesquisarTituloPagamento();
        break;
	  case "Dados Cheque":
		this.form = this.formBuilder.group({
			nomeEmitente: [, Validators.required],
			nomeApresentante: [, Validators.required],
			agencia: [, Validators.required],
			digitoAgencia: [, Validators.required],
			numeroConta: [, Validators.required],
			digitoConta: [, Validators.required],
			numeroCheque: [, Validators.required],
			dataEmissao: [, Validators.required],
			dataVencimento: [, Validators.required],
			representante: [],
			banco: [, Validators.required],
			portador: [, Validators.required],
			situacaoCheque: [, Validators.required],
			motivoDevolucao: new UntypedFormControl({ value: '', disabled: true }),
			idRepresentante: [, ],
			idBanco: [, ],
			idPortador: [, ],
			idSituacao: [, ],
			idMotivoDevolucao: [, ]
		});
		if(this.dialogData['pagamentos']) {
			this.exibirCarregando();
			let registro;
			if(this.dialogData['existente']){
				registro = this.dialogData.pagamentos[this.dialogData.rowPagamentoIndex].cheques[0];
			}else{
				if(this.dialogData.pagamentos[this.dialogData.rowPagamentoIndex].dadosCheque){
					registro = this.dialogData.pagamentos[this.dialogData.rowPagamentoIndex].dadosCheque[0];
				}else{
					registro = this.dialogData.pagamentos[this.dialogData.rowPagamentoIndex];
				}
			}
			this.preencheCamposModalCheque(registro);
			this.carregaAutocompleteCamposModalCheques();
			this.escondeCarregando();
		}else{
			if(this.dialogData['existente']){
				this.exibirCarregando();
		    this.tituloService.consultaCheque({ rowId: this.dialogData.rowid }).subscribe({
          next: (response) => {
            this.escondeCarregando();
					  const titulo = response.body.cheques;
					  this.preencheCamposModalCheque(titulo[0]);
					  this.carregaAutocompleteCamposModalCheques();
				  }, 
          error: (err) => { this.genericErrorTreat(err) } });			}else{
				this.exibirCarregando();
				this.tituloService.carregaLiquidacaoTitulo({ idTitulo: this.dialogData['idTitulo'], listarPagamentos: true }).subscribe({
          next: (response) => {
            this.escondeCarregando();
					  const titulo = response.body.retorno.registro;
					  this.dialogData['titulo'] = titulo[0];
					  this.carregaAutocompleteCamposModalCheques();
				  }, 
          error: (err) => { this.genericErrorTreat(err) }});
			}
		}
	 	break;
      case "Prorrogar":
        this.form = this.formBuilder.group({
          titulo: this.dialogData['titulo'],
          dataVencimentoOriginal: new UntypedFormControl({ value: this.datePipe.transform(this.dialogData['titulo']['dataVencimento'], 'yyyy-MM-dd'), disabled: true }),
          dataVencimento: new UntypedFormControl({ value: this.datePipe.transform(this.dialogData['titulo']['dataVencimento'], 'yyyy-MM-dd') }, Validators.required),
          portadorOriginal: new UntypedFormControl({ value: '', disabled: true }),
          valorOriginal: new UntypedFormControl({ value: this.dialogData['titulo']['valorTitulo'], disabled: true }),
          valorALiquidar: [this.dialogData['titulo']['valorSaldo'], Validators.required],
          valorDesconto: [this.dialogData['titulo']['valorDesconto'], Validators.required],
          valorAbatimento: [this.dialogData['titulo']['valorAbatimento'], Validators.required],
          valorJuros: [this.dialogData['titulo']['valorJuros'], Validators.required],
          observacoes: [""]
        });
        break;
      case "Negociação":
        this.form = this.formBuilder.group({
          titulo: this.dialogData['titulo'],
          dataVencimento: new UntypedFormControl({ value: this.datePipe.transform(this.dialogData['titulo']['dataVencimento'], 'yyyy-MM-dd'), disabled: true }),
          portadorOriginal: new UntypedFormControl({ value: '', disabled: true }),
          valorOriginal: new UntypedFormControl({ value: this.dialogData['titulo']['valorTitulo'], disabled: true }),
          valorALiquidar: [this.dialogData['titulo']['valorSaldo'], Validators.required],
          valorDesconto: [this.dialogData['titulo']['valorDesconto'], Validators.required],
          valorAbatimento: [this.dialogData['titulo']['valorAbatimento'], Validators.required],
          valorJuros: [this.dialogData['titulo']['valorJuros'], Validators.required],
          condicaoDePagamento: [,],
          observacoes: [""]
        });
        break;
      case "Liquidação Automática":
        this.form = this.formBuilder.group({
          titulo: this.dialogData['titulo'],
          codPortador: [, Validators.required],
          reprocessar: false,
          portador: [, Validators.required],
        });
        this.portadorService.listarTodos().subscribe({
          next: (response) => {
            this.escondeCarregando();
            const resultado = response.body.retorno.registro

            this.listaPortadores = resultado;

            if (this.listaPortadores === undefined) {
              this.listaPortadores = [];
            }

            let codigo = this.form.controls['codPortador'].value;

            if (codigo != 0) {
              let selecionado: Portador = <Portador>this.listaPortadores.filter(registro => registro.idPortador == codigo)[0];
              if (selecionado)
                this.form.controls['portador'].setValue(selecionado);
            }

            this.listaPortadoresFiltrados = this.form.controls['portador'].valueChanges
              .pipe(
                startWith(''),
                map(value => value === undefined || value === null ? "" : value),
                map(value => typeof value === 'string' ? value : value.nomeBanco),
                map(name => {
                  return name ? this.filtraPortador(name) : this.listaPortadores.slice();
                }));

          },
          error: (err) => { this.genericErrorTreat(err); }
        });
      break;
      default:
        this.form = this.formBuilder.group({});
      break;
    }
  }

  atualizaValoresListasDivisao(lista: CadastroGenerico[], listaFiltrada: Observable<[CadastroGenerico]>, self: any) {
    self.listaDivisao = lista;
    self.listaDivisaoFiltradas = listaFiltrada;
    if(self.dialogData['titulo']['codigoDivisao']){
      const selecionado = self.listaDivisao.filter(registro => registro.codigoCadGenerico == self.dialogData['titulo']['codigoDivisao'])[0];
      if (selecionado){
        self.form.controls['codigoDivisao'].setValue(selecionado.codigoCadGenerico);
        self.form.controls['divisao'].setValue(selecionado);
      }
    }
  }
 

  pesquisarTituloPagamento()
  {
    this.exibirCarregando();
    this.tituloService.carregaLiquidacaoTitulo({ idTitulo: this.dialogData['idTitulo'], listarPagamentos: true }).subscribe({
      next: (response) => {
        this.dataSourcePagamento = new MatTableDataSource<Pagamento>(response.body.retorno.pagamentos);

        this.escondeCarregando();
        this.dialogData["titulo"] = response.body.retorno.registro[0];
        const dataAtual = new Date();
        dataAtual.setHours(0);
        dataAtual.setMinutes(0);
        dataAtual.setSeconds(0);
        dataAtual.setMilliseconds(0);

        this.form.controls["dataVencimento"].setValue(this.datePipe.transform(this.dialogData['titulo']['dataVencimento'], 'yyyy-MM-dd'))
        if (this.dialogData['titulo']['dataLiquidacao'])
        {
          this.form.controls["dataLiquidacao"].setValue(this.datePipe.transform(this.dialogData['titulo']['dataLiquidacao'], 'yyyy-MM-dd'));
        }
        else
        {
          this.form.controls["dataLiquidacao"].setValue(this.datePipe.transform(dataAtual, 'yyyy-MM-dd'));
        }
        this.form.controls["valorOriginal"].setValue(this.dialogData['titulo']['valorTitulo'])
        this.form.controls["valorALiquidar"].setValue(this.dialogData['titulo']['valorSaldo'])
        this.form.controls["valorDesconto"].setValue(this.dialogData['titulo']['valorDesconto'])
        this.form.controls["valorDescontoFinanceiro"].setValue(this.dialogData['titulo']['valorDescontoFinanceiro'])
        this.form.controls["valorDescontoTitulo"].setValue(this.dialogData['titulo']['valorDescontoTitulo'])
        this.form.controls["valorAbatimento"].setValue(this.dialogData['titulo']['valorAbatimento'])
        this.form.controls["valorJuros"].setValue(this.dialogData['titulo']['valorJuros'])
        this.form.controls["observacoes"].setValue(this.dialogData['titulo']['observacao'])
        this.form.controls["codPortadorOriginal"].setValue(this.dialogData['titulo']['idPortador'])
        this.form.controls["nomePessoa"].setValue(this.dialogData['titulo']['nomePessoa'])
        this.form.controls["numDocumento"].setValue(this.dialogData['titulo']['numDocumento'])
        this.form.controls["parcela"].setValue(this.dialogData['titulo']['parcela'])
        this.form.controls["nossoNumero"].setValue(this.dialogData['titulo']['nossoNumero'])
        this.form.controls["codPortador"].setValue(this.dialogData['titulo']['idPortador'])

        this.form.controls["valorOriginal"].disable()
        this.form.controls["valorALiquidar"].disable()
        this.form.controls["valorDescontoFinanceiro"].disable();

        this.indLiquidado = this.dialogData['titulo']['liquidado'];
        this.indCancelado = this.dialogData['titulo']['cancelado'];

        if (this.indLiquidado || this.indCancelado)
        {
          this.form.controls["dataLiquidacao"].disable();
          this.form.controls["portador"].disable();
          this.form.controls["valorDescontoTitulo"].disable();
          this.form.controls["valorAbatimento"].disable();
          this.form.controls["valorJuros"].disable();
          this.form.controls["observacoes"].disable();
        }
        else
        {
          this.form.controls["dataLiquidacao"].enable();
          this.form.controls["portador"].enable();
          this.form.controls["valorDescontoTitulo"].enable();
          this.form.controls["valorAbatimento"].enable();
          this.form.controls["valorJuros"].enable();
          this.form.controls["observacoes"].enable();
        }

        let vencimentoAux = new Date(this.form.controls['dataVencimento'].value);
        vencimentoAux.setTime(vencimentoAux.getTime() + vencimentoAux.getTimezoneOffset() * 60000);

        if (dataAtual.getTime() > vencimentoAux.getTime()) {
          this.form.controls['valorDescontoTitulo'].disable();
          if (!this.indLiquidado && !this.indCancelado)
          {
            this.indEmAtraso = true;
            this.form.controls['valorAbatimento'].enable();
          }
        }
        else
        {
          this.form.controls['valorAbatimento'].disable();
          if (!this.indLiquidado && !this.indCancelado)
          {
            this.form.controls['valorDesconto'].enable();
            this.form.controls['valorDescontoTitulo'].enable();
          }
        }

                
        this.form.controls["codigoDivisao"].setValue(this.dialogData['titulo']['codigoDivisao'])

        this.pesquisaCadastrosGenericos(
          'bas', 
          'Divisao', 
          'divisao', 
          'codigoDivisao', 
          this.atualizaValoresListasDivisao);

        this.pesquisaCadastrosGenericos(
          'bas',
          'MeioPagamento',
          'meioPagamento',
          'idMeioPagamento',
          this.atualizaValoresListasMeioPagamento
        );

        var tipoItemResponse = this.cadastroGenericoService.listAll(undefined, undefined, undefined, ['cad', 'TipoItem']);
        tipoItemResponse.then(
          success => {
            var tipoItem = success.find(tipoItem => tipoItem.descricao.toLowerCase().includes("despesa"));
            if (!tipoItem) {
              this.escondeCarregando();
              this.snackBar.openSnackBar("Não localizado TipoItem Despesa no Cadastro Genérico ", null, "Error");
              return;
            }

            var produtoFilter =
            {
              produtoCodInicial: '',
              produtoCodFinal: 'zzzzzzzzzzzzzzz',
              codigoTipoItem: tipoItem.id,
              codigoGrupoItem: 0,
              codigoMarcaItem: 0,
              codigoFamilia: 0,
              descricaoSituacaoOrdem: '',
            };

            this.produtoService.parameters.procedure = "pi-filtrar";
            this.produtoService.defaultFilterObject = produtoFilter;

            var produtoResponse = this.produtoService.setIdAndListAll("produtoDespesa",this.dialogData['titulo']['codigoProduto'], this.form, undefined, this, 'codigoProduto');

            produtoResponse.then(
              success => {
                this.escondeCarregando();
              },
              error => {
                this.escondeCarregando();
                TrataExcessao.TrataExcessao(error, this.authService, this.snackBar);
              }
            )
          }
        )

        this.exibirCarregando();
        this.portadorService.listarTodos().subscribe({
          next: (response) => {
            this.escondeCarregando();
            const resultado = response.body.retorno.registro

            this.listaPortadores = resultado;

            if (this.listaPortadores === undefined) {
              this.listaPortadores = [];
            }

            let codigo = this.form.controls['codPortador'].value;

            if (codigo != 0) {
              let selecionado: Portador = <Portador>this.listaPortadores.filter(registro => registro.idPortador == codigo)[0];
              if (selecionado)
                this.form.controls['portador'].setValue(selecionado);
              this.form.controls['portadorOriginal'].setValue(selecionado.nome)
            }

            this.listaPortadoresFiltrados = this.form.controls['portador'].valueChanges
              .pipe(
                startWith(''),
                map(value => value === undefined || value === null ? "" : value),
                map(value => typeof value === 'string' ? value : value.nomeBanco),
                map(name => {
                  return name ? this.filtraPortador(name) : this.listaPortadores.slice();
                }));

          }, 
          error: (err) => { this.genericErrorTreat(err) }
        });

      }, 
      error: (err) => {this.genericErrorTreat(err) }
    });
  }

  incluirRegistro() {
    var registro = new Pagamento();

    registro.sequenciaPagamento = this.sequenciaPagamento;
    this.sequenciaPagamento++;

    registro.idMeioPagamento = 0;
    registro.valor = 0;
    const data = new Date()
    registro.dataPagamento = this.formatDate(data);
    registro.idPagamento = null;
    this.dataSourcePagamento.data.push(registro);
    this.dataSourcePagamento.data = this.dataSourcePagamento.data;
  }

  removerRegistro(registro: Pagamento, $event) {
    let index = -1;
    this.dataSourcePagamento.data.find((reg, idx) => {
      if (reg.idPagamento && registro.idPagamento) {
        if (reg.idPagamento == registro.idPagamento) {
          index = idx
        }
      }
      else if (reg.idMeioPagamento == registro.idMeioPagamento && reg.valor == registro.valor && reg.dataPagamento == registro.dataPagamento) {
        index = idx;
      }
    });

    const confirmRemoveDialog = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: "Confirmar Exclusão de Registro",
        msg: `Tem certeza que deseja prosseguir com a Exclusão do Pagamento de valor R$ ${registro.valor}?`,
      },
    });

    confirmRemoveDialog.afterClosed().subscribe((result) => {
      if (result) {
        if (registro.rowid) {
          this.exibirCarregando();
          this.tituloService
            .excluirPagamento(registro.rowid)
            .subscribe({
              next: (response) => {
                this.escondeCarregando();
                this.snackBar.openSnackBar(
                  `Registro de valor R$ ${registro.valor} foi Excluído com Sucesso.`,
                  null);

                if (index >= 0) {
                  this.dataSourcePagamento.data.splice(index, 1);
                  this.dataSourcePagamento.data = this.dataSourcePagamento.data;
                }

                this.recalculaValorLiquidar(null);
                this.pesquisarTituloPagamento();

              },
              error: (err) => { this.genericErrorTreat(err) }
            });

        }
        else {
          this.escondeCarregando();
          this.snackBar.openSnackBar(
            `Registro de valor R$ ${registro.valor} foi Excluído com Sucesso.`,
            null);
          if (index >= 0) {
            this.dataSourcePagamento.data.splice(index, 1);
            this.dataSourcePagamento.data = this.dataSourcePagamento.data;
          }

        }
      }
    });
  }

  private pesquisaCadastrosGenericos(
    modulo: string,
    assunto: string,
    campo: string,
    campoCodigo: string,
    functionRetornoLista
  ) {
    this.cadastroGenericoService
      .pesquisarPorModuloAssunto(modulo, assunto)
      .subscribe({
        next: (response) => {
          this.escondeCarregando();
          var lista = response.body.retorno.registro;

          if (lista === undefined) {
            lista = [];
          }

          this.dataSourcePagamento.data.forEach(pagamento => {
            let codigoAux = pagamento.idMeioPagamento;

            if (codigoAux != 0) {
              let selecionado: CadastroGenerico = <CadastroGenerico>(
                lista.filter(
                  (registro) => registro.codigoCadGenerico == codigoAux
                )[0]
              );
              if (selecionado) {
                pagamento.meioPagamento = selecionado;
              }
            }
          });

          var listaFiltrada = this.form.controls[campo].valueChanges.pipe(
            startWith(''),
            map((value) =>
              typeof value === 'string' ? value : value.descricao
            ),
            map((name) => {
              return name
                ? this.filtraCadastroGenerico(lista, name)
                : lista.slice();
            })
          );

          functionRetornoLista(lista, listaFiltrada, this);
        },
        error: (err) => { this.genericErrorTreat(err) }
      });
  }

  private filtraCadastroGenerico(
    lista: CadastroGenerico[],
    value: string
  ): CadastroGenerico[] {
    const filterValue = value.toLowerCase();
    return lista.filter((item) =>
      item.descricao.trim().toLowerCase().includes(filterValue)
    );
  }

  getMeioPagamentoInputValue(pagamento: Pagamento){
    const el = this.listaMeioPagamento.find(el => {
      if(pagamento.idMeioPagamento && el.codigoCadGenerico == pagamento.idMeioPagamento){
        return el
      }
    })
    return el ? el.descricao : ""
  }

  verificaSeleciona(event, campo: string, campoCodigo: string, pagamento: Pagamento) {
    if (event.srcElement.value === '') {
      let index = -1;
      if (pagamento.rowid) {
        this.dataSourcePagamento.data.find((reg, idx) => {
          if (reg.rowid == pagamento.rowid) {
            index = idx;
          }
        })
      } else {
        this.dataSourcePagamento.data.find((reg, idx) => {
          if (reg.sequenciaPagamento == pagamento.sequenciaPagamento) {
            index = idx;
          }
        })
      }
      this.dataSourcePagamento.data[index][campo] = '';
      this.dataSourcePagamento.data[index][campoCodigo] = 0;
    }
  }

  changeMeioPagamento(e) {
    this.form.controls['meioPagamento'].setValue(e.target.value)
  }

  displayCadastroGenerico(registro: CadastroGenerico): string {
    return registro && registro.descricao ? registro.descricao : '';
  }

  selecionaCadastroGenerico(event, campo: string, pagamento: Pagamento) {
    let selecionado: CadastroGenerico = event.option.value;

    if (selecionado) {
      let index = -1;
      if (pagamento.rowid) {
        this.dataSourcePagamento.data.find((reg, idx) => {
          if (reg.rowid == pagamento.rowid) {
            index = idx;
          }
        })
      } else {
        this.dataSourcePagamento.data.find((reg, idx) => {
          if (reg.sequenciaPagamento == pagamento.sequenciaPagamento) {
            index = idx;
          }
        })
      }
      this.dataSourcePagamento.data[index][campo] = selecionado.codigoCadGenerico;
    }
  }

  selecionaCadastroGenericoDivisao(event, campo: string) {
    let selecionado: CadastroGenerico = event.option.value;

    if (selecionado) {
      this.form.controls[campo].setValue(selecionado.codigoCadGenerico);     
    }
  }

  atualizaValoresListasMeioPagamento(
    lista: CadastroGenerico[],
    listaFiltrada: Observable<[CadastroGenerico]>,
    self: any
  ) {
    self.listaMeioPagamento = lista;
    self.listaMeioPagamentoFiltradas = listaFiltrada;
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  public onDragOver(event): void {
    event.preventDefault();
    this.isDragged = true;
  }

  public onDragLeave(event): void {
    this.isDragged = false;
  }

  public onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragged = false;
    if (event.dataTransfer?.items) {
      for (var i = 0; i < event.dataTransfer.items.length; i++) {
        if (
          event.dataTransfer.items[i].kind === "file"
        ) {
          var file = event.dataTransfer.items[i].getAsFile();
          this.fileToUpload = file;
        }
      }
    }
  }

  cancelFile(event) {
    event.preventDefault()
    this.fileToUpload = null;
  }

  corrigirValorParaString(n: number): string {
    return n.toString().replace(".", ",")
  }

  setValorALiquidar() {
    if(!this.habilitaPagamentos){
      const valorOriginal = parseFloat(this.form.controls['valorOriginal'].value.toString().replace(",", "."))
      const valorALiquidar = parseFloat(this.form.controls['valorALiquidar'].value.toString().replace(",", "."))

      if (valorALiquidar == this.dialogData['titulo']['valorSaldo']) {
        this.firstComparison = false
        return
      }
      let diferenca;
      this.form.controls['valorALiquidar'].setValue(valorOriginal)
      if (valorALiquidar > valorOriginal) {
        diferenca = (valorALiquidar - valorOriginal).toFixed(4)
        this.form.controls['valorJuros'].setValue(diferenca)
        this.form.controls['valorAbatimento'].setValue(0)
        this.form.controls['valorDesconto'].setValue(0)
      }
      else if (!this.firstComparison) {
        this.form.controls['valorJuros'].setValue(0)
        const dataAtual = new Date();
        dataAtual.setHours(0);
        dataAtual.setMinutes(0);
        dataAtual.setSeconds(0);
        dataAtual.setMilliseconds(0);
        diferenca = (valorOriginal - valorALiquidar).toFixed(4)

        if (dataAtual < new Date(this.form.controls['dataVencimento'].value)) {
          this.form.controls['valorDesconto'].setValue(diferenca)
          this.form.controls['valorAbatimento'].setValue(0)
        } else {
          this.form.controls['valorAbatimento'].setValue(diferenca)
          this.form.controls['valorDesconto'].setValue(0)
        }
      }
    }
  }

  displayPortador(registro: Portador): string {
    return registro && registro.nome ? registro.nome : '';
  }

  selecionaPortador(event) {
    let selecionado: Portador = event.option.value;

    if (selecionado) {
      this.form.controls['codPortador'].setValue(selecionado.idPortador);
    }
  }

  selecionaGenerico(event, tipoCampo: string){
	const selecionado = event.option.value;
	switch(tipoCampo){
		case 'representante':
			this.form.controls['idRepresentante'].setValue(selecionado.codigoRepresentante);
			this.form.controls['representante'].setValue(selecionado.nomePessoa);
			break;
		case 'portador':
			this.form.controls['idPortador'].setValue(selecionado.idPortador);
			this.form.controls['portador'].setValue(selecionado.nome);
			break;
		case 'banco':
			this.form.controls['idBanco'].setValue(selecionado.codigoBanco);
			this.form.controls['banco'].setValue(selecionado.nomeBanco);
			break;
		case 'situacaoCheque':
			const motivoRejeicaoField = this.form.controls['motivoDevolucao'];
			this.form.controls['idSituacao'].setValue(selecionado.codigoCadGenerico);
			this.form.controls['situacaoCheque'].setValue(selecionado.descricao);
			if(selecionado.codigo === 4){
				motivoRejeicaoField.setValidators([Validators.required]);
				motivoRejeicaoField.enable();
			} else {
				motivoRejeicaoField.disable();
				motivoRejeicaoField.clearValidators();
				motivoRejeicaoField.setValue('');
				this.form.controls['idMotivoDevolucao'].setValue(null);
			}
			break;
		case 'devolucao':
			this.form.controls['idMotivoDevolucao'].setValue(selecionado.codigoCadGenerico);
			this.form.controls['motivoDevolucao'].setValue(selecionado.descricao);
			break;
		default:
			break;
	}
  }

  private filtraPortador(value: string): Portador[] {
    const filterValue = value.toLowerCase();
    return this.listaPortadores.filter(item => item.nome.trim().toLowerCase().includes(filterValue));
  }

  private showMessage(msg: string, type: string = "Success") {
    this.snackBar.openSnackBar(msg, null, type);
  }

  formatarOutputValorProduto(preco): number {
    if (typeof preco === 'string' || preco instanceof String) {
      preco = preco.replace("R$ ", "");
      preco = preco.replaceAll(".", "")
      preco = preco.replace(",", ".")
    }
    if ( preco == '' ){
      preco = '0'
    }
    return parseFloat(preco)
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  btnVoltar(){
    if(!this.dialogData.existente){
      const confirmCancelDataDialog = this.dialog.open(ConfirmModalComponent, {
        data: {
          title: "Dados não salvos",
          msg: `Os dados não serão salvos, tem certeza que deseja continuar?`,
        },
      });
      confirmCancelDataDialog.beforeClosed().subscribe((result) => {
        if(result){
          this.dialogRef.close();
        }
      });
    }else{
      this.dialogRef.close();
    }
  }

  async closeModal() {
    if (this.form.valid) {
      const titulo = this.dialogData['titulo'];
      if (this.dialogData['action'] == "Liquidar Manual") {

        titulo.idPortador = this.form.controls['codPortador'].value
        titulo.codigoFebraban = (this.form.controls['portador'].value)['codigoFebraban']
        titulo.dataLiquidacao = this.form.controls['dataLiquidacao'].value

        titulo.valorSaldo = this.form.controls['valorALiquidar'].value
        if (typeof titulo.valorSaldo === 'string' || titulo.valorSaldo instanceof String) {
          titulo.valorSaldo = parseFloat(titulo.valorSaldo.replace(",", "."))
        }
        titulo.valorDesconto = this.form.controls['valorDesconto'].value
        if (typeof titulo.valorDesconto === 'string' || titulo.valorDesconto instanceof String) {
          titulo.valorDesconto = parseFloat(titulo.valorDesconto.replace(",", "."))
        }
        titulo.valorAbatimento = this.form.controls['valorAbatimento'].value
        if (typeof titulo.valorAbatimento === 'string' || titulo.valorAbatimento instanceof String) {
          titulo.valorAbatimento = parseFloat(titulo.valorAbatimento.replace(",", "."))
        }
        titulo.valorJuros = this.form.controls['valorJuros'].value
        if (typeof titulo.valorJuros === 'string' || titulo.valorJuros instanceof String) {
          titulo.valorJuros = parseFloat(titulo.valorJuros.replace(",", "."))
        }
        titulo.observacao = this.form.controls['observacoes'].value
        this.exibirCarregando();
        this.tituloService.salvaLiquidacaoTitulo(titulo).subscribe({
          next: (response) => {            
            this.escondeCarregando();
            this.showMessage("Informações salvas com Sucesso!")
            this.dialogRef.close(this.form.getRawValue());
          },
          error: (err) => { this.genericErrorTreat(err) }
        });
      }
      if (this.dialogData['action'] == "Pagamentos") {

        titulo.idPortador = this.form.controls['codPortador'].value
        titulo.codigoFebraban = (this.form.controls['portador'].value)['codigoFebraban']
        titulo.dataLiquidacao = this.form.controls['dataLiquidacao'].value

        titulo.valorSaldo = this.form.controls['valorALiquidar'].value
        if (typeof titulo.valorSaldo === 'string' || titulo.valorSaldo instanceof String) {
          titulo.valorSaldo = parseFloat(titulo.valorSaldo.replace(",", "."))
        }
        titulo.valorDesconto = this.form.controls['valorDesconto'].value
        if (typeof titulo.valorDesconto === 'string' || titulo.valorDesconto instanceof String) {
          titulo.valorDesconto = parseFloat(titulo.valorDesconto.replace(",", "."))
        }
        titulo.valorAbatimento = this.form.controls['valorAbatimento'].value
        if (typeof titulo.valorAbatimento === 'string' || titulo.valorAbatimento instanceof String) {
          titulo.valorAbatimento = parseFloat(titulo.valorAbatimento.replace(",", "."))
        }
        titulo.valorJuros = this.form.controls['valorJuros'].value
        if (typeof titulo.valorJuros === 'string' || titulo.valorJuros instanceof String) {
          titulo.valorJuros = parseFloat(titulo.valorJuros.replace(",", "."))
        }
        titulo.observacao = this.form.controls['observacoes'].value;

        titulo.codigoDivisao = this.form.controls['codigoDivisao']?.value;
        titulo.codigoProduto = this.form.controls['produtoDespesa']?.value?.codigoProduto;

        const params = {
          registro: [
            titulo
          ],
          pagamentos: this.formataValorNumerico(this.dataSourcePagamento.data)
        }

        this.exibirCarregando();
        this.tituloService.salvaPagamentos(params).subscribe({
          next: (response) => {            
            this.escondeCarregando();
            this.showMessage("Informações salvas com Sucesso!")
            this.dialogRef.close(this.form.getRawValue());
          }, 
          error: (err) => { this.genericErrorTreat(err) }
        });
      }
	  if(this.dialogData['action'] == 'Dados Cheque'){
		const dadosCheque = {
			idBanco: this.form.controls['idBanco'].value,
			idRepresentante: this.form.controls['idRepresentante'].value,
			idSituacao: this.form.controls['idSituacao'].value,
			idMotivoDevolucao: this.form.controls['idMotivoDevolucao'].value,
			idPortador: this.form.controls['idPortador'].value,
			nomeEmitente: this.form.controls['nomeEmitente'].value,
			numeroConta: this.form.controls['numeroConta'].value,
			digitoConta: this.form.controls['digitoConta'].value,
			numeroCheque: this.form.controls['numeroCheque'].value,
			dataEmissao: this.form.controls['dataEmissao'].value,
			dataApresentacao: this.form.controls['dataVencimento'].value,
			agencia: this.form.controls['agencia'].value,
			digitoAgencia: this.form.controls['digitoAgencia'].value,
			nomeApresentante: this.form.controls['nomeApresentante'].value,
		}
		if(this.dialogData.existente){
			const auxDadosRegistro = { ...titulo, ...dadosCheque };
			this.exibirCarregando();
			this.tituloService.salvaCheque(auxDadosRegistro).subscribe({
        next: (response) => {
				  this.escondeCarregando();			    
          this.showMessage("Informações salvas com Sucesso!");
			    this.dialogRef.close(this.form.getRawValue());
			  }, 
        error: (err) => { this.genericErrorTreat(err) }});
		}else{
			const auxDadosRegistro = [dadosCheque];
			const { pagamentos, rowPagamentoIndex } = this.dialogData;
			const dadosPagamentoFormatado = pagamentos;
			dadosPagamentoFormatado[rowPagamentoIndex] = { ...dadosPagamentoFormatado[rowPagamentoIndex], dadosCheque: auxDadosRegistro };
			this.showMessage("Informações adicionadas ao registro.");
			this.dialogRef.close(dadosPagamentoFormatado);
		}
	  }
      if (this.dialogData['action'] == "Liquidação Automática") {
        if (this.fileToUpload) {
          const conteudoArquivo = await Promise.all([this.fileToUpload].map(f => this.getBase64(this.fileToUpload)));
          const param = {
            idPortador: this.form.controls["codPortador"].value,
            reprocessar: this.form.controls["reprocessar"].value,
            nomeArquivo: this.fileToUpload?.name,
            conteudoArquivo: conteudoArquivo[0]
          }
          this.exibirCarregando();
          this.dataSourceResultado = new MatTableDataSource<ResultadoArquivoRetorno>();
			    this.tituloService.LiquidacaoAutomatica(param).subscribe({
            next: (response) => {
              this.escondeCarregando();
              this.liquiAutomaticaCarregou = true;
              this.dataSourceResultado = new MatTableDataSource<ResultadoArquivoRetorno>(response.body.retorno.retornoArquivo);
              this.dataSourceResultado.paginator = this.resultadoArquivo;
              this.dataSourceResultado.sort = this.sort;
            }, 
            error: (err) => { this.genericErrorTreat(err) }});
        } else {
          this.showMessage("Nenhum arquivo enviado", "Warn");
        }
      }
    } else {
      this.showMessage("Campos obrigatórios não foram preenchidos", "Warn");
    }
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.onload = function () {
        return resolve(btoa(fileReader.result?.toString() ?? ''));
      }
      fileReader.readAsBinaryString(file);
    })
  }

  listarMovimentos() {
    this.exibirCarregando();
    this.tituloService.ListarMovimentos(this.dialogData.idTitulo).subscribe({
      next: (response) => {        
        this.escondeCarregando();
        this.dataSource = new MatTableDataSource<Titulo>(response.body.retorno.registro);
        this.dataSource.paginator = this.paginatorMovto;
        this.dataSource.sort = this.sortMovto;
      },
      error: (err) => { this.genericErrorTreat(err) }
    });
  }

  ngOnInit(): void {
    this.consultaPermissaoAcesso();
    if (this.dialogData.action == "Liquidar Manual" || this.dialogData.action == "Liquidação Automática" || this.dialogData.action == "Pagamentos" || this.dialogData.action == "Dados Cheque") {
      this.habilitaPagamentos = (this.dialogData.action == "Pagamentos")
      this.createForm();
    } else if (this.dialogData.action == "Exibir Movimentos") {
      this.listarMovimentos()
    }
  }

  consultaPermissaoAcesso() {
    this.exibirCarregando();
    this.acessoService.pesquisaPermissoAcesso().subscribe({
      next: (response) => {
        this.escondeCarregando();
        this.acesso = response.body.retorno.registro[0];
      },
      error: (err) => { this.genericErrorTreat(err) }
    });
  }

  formControlValueToDecimal(name:string){
    if(this.form?.controls[name]?.value){
      return parseFloat(parseFloat(this.form.controls[name].value.toString().replace(",", ".")).toFixed(2))
    }
    else{
      return 0
    }
  }

  recalculaValorLiquidar(event: FocusEvent | null){
    if(this.habilitaPagamentos){
      const titulo = this.dialogData['titulo'];
      titulo.valorALiquidar = this.formControlValueToDecimal('valorALiquidar')
      titulo.valorAbatimento = this.formControlValueToDecimal('valorAbatimento')
      titulo.valorDescontoTitulo = this.formControlValueToDecimal('valorDescontoTitulo')
      titulo.valorJuros = this.formControlValueToDecimal('valorJuros')
      titulo.valorTitulo = parseFloat(parseFloat(titulo.valorTitulo.toString().replace(",", ".")).toFixed(2))
      titulo.valorALiquidar = (titulo.valorTitulo + titulo.valorJuros - titulo.valorAbatimento - titulo.valorDescontoTitulo - titulo.valorDescontoFinanceiro).toFixed(2);

      let valorPagamentos = 0;

      this.dataSourcePagamento.data.forEach(element => {
        if( this.formatarOutputValorProduto(element.valor) ){
          valorPagamentos += parseFloat(this.formatarOutputValorProduto(element.valor).toFixed(2));
        }
      });

      if (this.indEmAtraso)
      {
        if (valorPagamentos > titulo.valorALiquidar)
        {
          titulo.valorJuros += valorPagamentos - titulo.valorALiquidar; 
          titulo.valorALiquidar = (titulo.valorTitulo + titulo.valorJuros - titulo.valorAbatimento - titulo.valorDescontoTitulo - titulo.valorDescontoFinanceiro - valorPagamentos).toFixed(2);
        }
        else
        {
          titulo.valorALiquidar = (titulo.valorTitulo + titulo.valorJuros - titulo.valorAbatimento - titulo.valorDescontoTitulo - titulo.valorDescontoFinanceiro - valorPagamentos).toFixed(2);
        }
      }
      else
      {
        titulo.valorALiquidar = (titulo.valorTitulo + titulo.valorJuros - titulo.valorAbatimento - titulo.valorDescontoTitulo - titulo.valorDescontoFinanceiro - valorPagamentos).toFixed(2);
      }

      if (titulo.valorALiquidar < 0) {
        this.showMessage("Valor Total dos Pagamentos É Maior do Que o Valor do Saldo do Título","Warn");
        if (event)
        {
          const input: HTMLInputElement = event.target as HTMLInputElement;
          input.focus();
          input.select();
        }
        return;
      }

      if (this.indEmAtraso)
      {
        this.form.controls['valorJuros'].setValue(titulo.valorJuros.toFixed(2))  
      }
      if (this.indLiquidado)
      {
        titulo.valorALiquidar = 0;
      }
      this.form.controls['valorALiquidar'].setValue(titulo.valorALiquidar)
    }
  }

  opcaoChequeSelecionado(obj){
    let actions = {
      action: '',
      idTitulo: null,
      existente: false,
      pagamentos: [] as Array<any>,
      rowid: undefined,
      rowPagamentoIndex: 0
    };
    actions.action = obj.action;
	  actions.rowPagamentoIndex = obj.rowIndex;
    if (obj.element) {
	    if(obj.element.cheques){
		    actions.existente = true;
		    actions.rowid = obj.element.cheques[0].rowid;
	    }
      actions.idTitulo = this.dialogData.idTitulo;
	    actions.pagamentos = this.dataSourcePagamento.data;
    }
    var dialogConfig = new MatDialogConfig();
    dialogConfig.height = "80%";
    dialogConfig.width = "55%";
    dialogConfig.data = actions;

	  this.exibirCarregando();
    const action = this.dialog.open(ActionsModalComponent, dialogConfig);
    action.afterClosed().subscribe((result) => {
      if(result){
        if(!actions.existente){
          this.dataSourcePagamento.data = result;
        }
      }
      this.escondeCarregando();
    });
  }

  private carregaRepresentantes(){
	const titulo = this.dialogData['titulo'];
	this.representanteService.listarTodos().subscribe({
    next: (response) => {
      const { retorno } = response.body;
      if(retorno){
        this.listaRepresentantes = retorno.registro;
        if(titulo){
          const representante = this.listaRepresentantes.find((item) => { return  item.codigoRepresentante === titulo.idRepresentante });
          if(representante){
            this.form.controls['representante'].setValue(representante.nomePessoa);
            this.form.controls['idRepresentante'].setValue(representante.codigoRepresentante);
          }
        }
      }
    }, 
    error: (err) => { this.genericErrorTreat(err) }});
  }

  private carregaBancos(){
	const titulo = this.dialogData['titulo'];
	this.bancoService.listarTodos().subscribe({
    next: (response) => {
		const { retorno } = response.body;
		if(retorno){
			this.listaBancos = retorno.registro;
			if(titulo){
				const banco = this.listaBancos.find((item) => { return  item.codigoBanco === titulo.idBanco });
				if(banco){
					this.form.controls['banco'].setValue(banco.nomeBanco);
					this.form.controls['idBanco'].setValue(banco.codigoBanco);
				}
			}
		}
	}, error: (err) => { this.genericErrorTreat(err) }});
  }

  private carregaPortadores(){
    const titulo = this.dialogData['titulo'];
    this.portadorService.listarTodos().subscribe({
      next: (response) => {
      const { retorno } = response.body;
      if(retorno){
        this.listaPortadores = retorno.registro;
        if(titulo){
          const portador = this.listaPortadores.find((item) => { return  item.idPortador === titulo.idPortador });
          if(portador){
            this.form.controls['portador'].setValue(portador.nome);
            this.form.controls['idPortador'].setValue(portador.idPortador);
          }
        }
      }
    }, error: (err) => { this.genericErrorTreat(err) }});
  }

  private carregaSituacaoCheque(){
    const titulo = this.dialogData['titulo'];
    this.cadastroGenericoService.pesquisarPorModuloAssunto('BAS', 'SituacaoCheque').subscribe({
      next: (response) => {
        const { retorno } = response.body;
        if(retorno){
          this.listaSituacaoCheque = retorno.registro;
          if(titulo){
            const situacaoCheque = this.listaSituacaoCheque.find((item) => { return  item.codigoCadGenerico === titulo.idSituacao });
            if(situacaoCheque){
              this.form.controls['situacaoCheque'].setValue(situacaoCheque.descricao);
              this.form.controls['idSituacao'].setValue(situacaoCheque.codigoCadGenerico);
            }
          }
        }
      }, 
      error: (err) => { this.genericErrorTreat(err) }});
  }

  private carregaMotivoDevolucao(){
    const titulo = this.dialogData['titulo'];
    this.cadastroGenericoService.pesquisarPorModuloAssunto('BAS', 'MotivoDevolucaoCheque').subscribe({
      next: (response) => {
        const { retorno } = response.body;
        if(retorno){
          this.listaMotivoDevolucao = retorno.registro;
          if(titulo){
            const devolucao = this.listaMotivoDevolucao.find((item) => { return  item.codigoCadGenerico === titulo.idMotivoDevolucao });
            if(devolucao){
              this.form.controls['motivoDevolucao'].setValue(devolucao.descricao);
              this.form.controls['idMotivoDevolucao'].setValue(devolucao.codigoCadGenerico);
            }
          }
        }
      }, error: (err) => { this.genericErrorTreat(err) }});
    }

  private formataValorNumerico(valores){
    const formatado = valores.map(el => {
        if (typeof el.valor === 'string') {
            el.valor = this.formatarOutputValorProduto(el.valor);
          }
          if (!el.idPagamento) {
            delete el.sequenciaPagamento
          }
          if(el.meioPagamento){
            delete el.meioPagamento
          }
          return el
      });
    return formatado;
  }

  private preencheCamposModalCheque(registro){
    this.dialogData['titulo'] = registro;
    this.form.controls["dataEmissao"].setValue(this.datePipe.transform(this.dialogData['titulo']['dataEmissao'], 'yyyy-MM-dd'));
    this.form.controls["dataVencimento"].setValue(this.datePipe.transform(this.dialogData['titulo']['dataApresentacao'], 'yyyy-MM-dd'));
    this.form.controls['nomeEmitente'].setValue(this.dialogData['titulo']['nomeEmitente']);
    this.form.controls['nomeApresentante'].setValue(this.dialogData['titulo']['nomeApresentante']);
    this.form.controls['agencia'].setValue(this.dialogData['titulo']['agencia']);
    this.form.controls['digitoAgencia'].setValue(this.dialogData['titulo']['digitoAgencia']);
    this.form.controls['numeroConta'].setValue(this.dialogData['titulo']['numeroConta']);
    this.form.controls['digitoConta'].setValue(this.dialogData['titulo']['digitoConta']);
    this.form.controls['numeroCheque'].setValue(this.dialogData['titulo']['numeroCheque']);
  }

  private carregaAutocompleteCamposModalCheques(){
    this.carregaRepresentantes();
    this.carregaBancos();
    this.carregaPortadores();
    this.carregaSituacaoCheque();
    this.carregaMotivoDevolucao();
  }
}
